import BigNumber from 'bignumber.js'

const earFormat = (value) => BigNumber(value).dp(4, BigNumber.ROUND_FLOOR).toString(10)

const otherFormat = (value) => BigNumber(value).dp(3, BigNumber.ROUND_FLOOR).toString(10)

const addressFormat = (value) => value.replace(value.substr(6, value.length - 6 - 4), "...")


export { earFormat, otherFormat, addressFormat }